import React, { useEffect, useState } from "react";
import { useNavigationType } from "react-router-dom";
import styled, { css } from "styled-components";

const PAGE_COUNT_AMOUNT = 10

const Paging = ({ children, ...props }) => {
    const { name, total, pageNumState, viewCount } = props;
    const navigationType = useNavigationType();

    const [pageData, setPageData] = useState([{ pageNum: 1 }]);
    const [pageArrow, setPageArrow] = useState({ prev: false, next: false, start: false, end: false });
    const totalPageCount = (Math.ceil((total || 0) / viewCount))

    const pageClickHandler = (num) => {
        localStorage.setItem(`${name}_page`, num);
        pageNumState[1](num);
    };

    // 페이지 진입, 뒤로가기 복원
    useEffect(() => {
        if (navigationType === "PUSH" || navigationType === "REPLACE") {
            // 페이지 진입
            pageNumState[1](1);
            localStorage.setItem(`${name}_page`, 1);
        } else if (navigationType === "POP") {
            // 뒤로가기
            pageNumState[1](parseInt(localStorage.getItem(`${name}_page`)) || 1);
        }
    }, [navigationType]);

    useEffect(() => {
        // pageNumState[0] : curPageNum
        let startNum = Math.floor((pageNumState[0] - 1) / PAGE_COUNT_AMOUNT) * PAGE_COUNT_AMOUNT + 1
        let endNum = Math.min(startNum + PAGE_COUNT_AMOUNT - 1, totalPageCount)

        let tmp = [];
        for (let i = startNum; i <= endNum; i++) {
            tmp.push({ pageNum: i});
        }

        // 현재 페이지 번호에 따라 처음, 이전, 다음, 마지막 버튼 활성화 유무 지정
        setPageArrow({
            prev: pageNumState[0] > 1,
            next: pageNumState[0] < totalPageCount,
            start: startNum > 1,
            end: endNum < totalPageCount,
        })

        setPageData(tmp);

        console.log(`@pageNumState[0] (curPage): ${pageNumState[0]},`, `@total: ${total},`, `@viewCount: ${viewCount},`, `@totalPageCount: ${totalPageCount} / `, `@startNum: ${startNum}, @endNum: ${endNum}`);
    }, [pageNumState, total, viewCount, totalPageCount]);

    return (
        <>
        {/* 전체 페이지 수가 1 이상일 때만 렌더 */}
        {totalPageCount > 0 && (
            <>
                <CustomWrap>
                    {/* 시작 */}
                    {pageArrow.start && (
                        <CustomPagingBtn type={"arrow"} onClick={() => pageClickHandler(1)}>
                            <img src="/image/icn_chevron_left.svg" /><img src="/image/icn_chevron_left.svg" />
                        </CustomPagingBtn>
                    )}

                    {/* 이전 */}
                    <CustomPagingBtn type={"arrow"} onClick={() => pageClickHandler(pageNumState[0] - 1)} disabled={!pageArrow.prev}>
                        <img src={pageArrow.prev ? "/image/icn_chevron_left.svg" : "/image/icn_chevron_left_gray.svg"} />
                    </CustomPagingBtn>

                    {/* 페이지 번호 */}
                    {pageData.map((el) => {
                        return (
                            <CustomPagingBtn type={"num"} key={el.pageNum} active={pageNumState[0] === el.pageNum ? "active" : ""} onClick={() => pageClickHandler(el.pageNum)}>
                                {el.pageNum}
                            </CustomPagingBtn>
                        );
                    })}

                    {/* 다음 */}
                    <CustomPagingBtn type={"arrow"} onClick={() => pageClickHandler(pageNumState[0] + 1)} disabled={!pageArrow.next}>
                        <img src={pageArrow.next ? "/image/icn_chevron_right.svg" : "/image/icn_chevron_right_gray.svg" } />
                    </CustomPagingBtn>
                    
                    {/* 마지막 */}
                    {pageArrow.end && (
                        <CustomPagingBtn type={"arrow"} onClick={() => pageClickHandler(totalPageCount)}>
                            <img src="/image/icn_chevron_right.svg" /><img src="/image/icn_chevron_right.svg" />
                        </CustomPagingBtn>
                    )}
                </CustomWrap>
            </>
        )}
        </>
    );
};

const CustomWrap = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
`;

const CustomPagingBtn = styled.button`
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 48px;
    height: 48px;
    font-family: 'Gotham';
    font-size: 16px;
    color: var(--dark-color);
    border-radius: 24px;
    border: 0;
    background-color: var(--white-color);
    cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};

    ${({ active, disabled }) => active !== 'active' && !disabled &&`
        &:hover {
            background-color: var(--bg-light);
        }
    `}
    ${({ active }) => active === "active" && `background-color: var(--bg-dark);`}
    ${({ type }) => type === "arrow" && `border: 0`}
`;

export default Paging;